import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/common/queryKeys";
import { smallPackagingAPI } from "@api/smallPackaging";

export const usePrintProductListQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CUSTOMIZING.PRINT.PRODUCTS],
    queryFn: async () => {
      const body = { modes: "ProductsListSet" };
      const res = await smallPackagingAPI(body);
      if (res.Code === "0000") {
        return res.Data?.rows.data;
      }
      throw new Error(res.Data?.Msg || "상품 목록을 불러오지 못했습니다.");
    },
  });
};

export const usePrintCartItemsQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CUSTOMIZING.PRINT.CART],
    queryFn: () => {
      const items = JSON.parse(sessionStorage.getItem("printCart") || "[]");
      return items;
    },
    enabled: typeof window !== "undefined", // 클라이언트 환경일 때만 실행
  });
};
